var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-members1{fill:#fdda18;}.cls-members2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u4F1A\u5458") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-members1",
    d: "M7.33,1.58h9.33a2.06,2.06,0,0,1,1.65.82l5,6.65a2.07,2.07,0,0,1-.16,2.69l-9.69,10a2.08,2.08,0,0,1-2.93.05l-.05-.05L.8,11.76A2.07,2.07,0,0,1,.64,9.07l5-6.67A2.08,2.08,0,0,1,7.33,1.58Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-members2",
    d: "M16.15,8.72a.7.7,0,0,1,1.08,0,1,1,0,0,1,.05,1.16l-.05.07-4.69,5.33a.7.7,0,0,1-1,.06l0-.06L6.77,10a1,1,0,0,1,0-1.23.7.7,0,0,1,1-.06l.06.06L12,12.88l4.15-4.16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembers);
export default __webpack_public_path__ + "static/media/members.3fc0ea25.svg";
export { ForwardRef as ReactComponent };